// Keep the Beam site open when a visitor follows a PDF or social/video link.
(() => {
  const socialDomains = [
    'youtube.com', 'youtu.be', 'youtube-nocookie.com',
    'linkedin.com', 'lnkd.in', 'twitter.com', 'x.com', 't.co',
    'facebook.com', 'fb.com', 'fb.me', 'instagram.com',
    'threads.net', 'threads.com', 'tiktok.com',
    'vimeo.com', 'dailymotion.com', 'twitch.tv',
    'pinterest.com', 'pin.it', 'reddit.com', 'redd.it',
    'blogger.com', 'blogspot.com', 'blogspot.com.au',
    'flickr.com', 'tumblr.com', 'bsky.app',
  ];

  function prepareLink(link) {
    if (!link.matches('a[href]')) return;

    let url;
    let path;
    try {
      url = new URL(link.getAttribute('href'), document.baseURI);
      if (!['http:', 'https:', 'blob:'].includes(url.protocol)) return;
      path = decodeURIComponent(url.pathname);
    } catch {
      return;
    }

    const pdfType = link.getAttribute('type')?.split(';')[0].trim().toLowerCase() === 'application/pdf';
    const pdfDownload = /\.pdf$/i.test(link.getAttribute('download') || '');
    const isPdf = /\.pdf$/i.test(path) || pdfType || pdfDownload;
    const isSocial = ['http:', 'https:'].includes(url.protocol) && socialDomains.some(
      (domain) => url.hostname === domain || url.hostname.endsWith(`.${domain}`)
    );
    if (!isPdf && !isSocial) return;

    link.setAttribute('target', '_blank');
    link.relList.add('noopener');
    if (isPdf) {
      // PDF links should display the document rather than force a download.
      if (pdfDownload && !pdfType) link.setAttribute('type', 'application/pdf');
      link.removeAttribute('download');
    }
  }

  function prepareTree(root) {
    if (root.nodeType === 1) prepareLink(root);
    root.querySelectorAll?.('a[href]').forEach(prepareLink);
  }

  prepareTree(document);

  // Covers product panels, search results, and sections inserted after load.
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') prepareLink(record.target);
      else record.addedNodes.forEach(prepareTree);
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href', 'type', 'download'],
  });

  // Set the target before native mouse, touch, or keyboard link navigation,
  // including a link inserted and activated in the same JavaScript task.
  for (const eventName of ['click', 'auxclick', 'contextmenu']) {
    document.addEventListener(eventName, (event) => {
      const link = event.target.closest?.('a[href]');
      if (link) prepareLink(link);
    }, true);
  }
})();
